import router from './router'
import personnelDisputeMessages from './localization'

export default {
  router,
  localization: personnelDisputeMessages,
}
